module.exports = __webpack_public_path__ + "static/media/video-see-how.cd8a04e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-see-how.jpg
// module id = 97
// module chunks = 3